<template>
  <div class="wg-heading" :class="['wg-h' + (config.level || 1), 'wg-align-' + (config.align || 'left')]">
    <div class="wg-heading-text">{{ config.text || '' }}</div>
    <div v-if="config.subtitle" class="wg-heading-sub">{{ config.subtitle }}</div>
  </div>
</template>

<script>
export default {
  name: 'HeadingWidget',
  props: {
    inputs: { type: Object, default: () => ({}) },
    config: { type: Object, default: () => ({}) },
    scope: { type: Object, default: () => ({}) },
    width: { type: Number, default: 0 },
    height: { type: Number, default: 0 },
  },
};
</script>

<style scoped>
.wg-heading { height: 100%; display: flex; flex-direction: column; justify-content: center; padding: 4px 8px; color: #1A1A2E; }
.wg-heading-text { font-weight: 600; line-height: 1.15; }
.wg-h1 .wg-heading-text { font-size: 24px; }
.wg-h2 .wg-heading-text { font-size: 18px; }
.wg-h3 .wg-heading-text { font-size: 15px; }
.wg-heading-sub { margin-top: 3px; font-size: 12.5px; color: #6B7280; }
.wg-align-center { text-align: center; }
.wg-align-right { text-align: right; }
</style>
